export default "__VITE_ASSET__DV$faabT__"